import React, { ComponentPropsWithoutRef, ReactNode, forwardRef } from 'react';

import { Box, Flex, Space, Text } from '@mantine/core';
import { InfoComponent } from 'components/InfoComponent';

interface MultiSelectItemProps extends ComponentPropsWithoutRef<'div'> {
  label: string;
  value: string;
  iconComponent: ReactNode;
  info?: string;
}

export const MultiSelectItem = forwardRef<HTMLDivElement, MultiSelectItemProps>(
  ({ label, iconComponent, info, ...others }: MultiSelectItemProps, ref) => {
    return (
      <Box ref={ref} {...others} style={{ paddingLeft: 9 }}>
        <Flex direction="row" align="center" justify="space-between">
          <Flex direction="row" align="center">
            {iconComponent}
            <Space w={10} />
            <Text>{label}</Text>
          </Flex>

          {info && <InfoComponent withinPortal width={250} position="right" contentTranslationKey={info} />}
        </Flex>
      </Box>
    );
  }
);

MultiSelectItem.displayName = 'MultiSelectItem';
